// eslint-disable-next-line import/prefer-default-export
export function toFmlxOptions(enumObj) {
  const options = [];
  const enumKeys = Object.keys(enumObj);
  for (let index = 0; index < enumKeys.length; index += 1) {
    const key = enumKeys[index];
    options.push({
      Id: enumObj[key],
      Name: enumObj[key],
    });
  }
  return options;
}
